/** #773 — best-effort cloud push of a user queue selection (extracted from queueOwnerCommit). */
import { CLOUD_API_URL } from '../config/serverConfig';

export function trackIdFromRow(track: Record<string, unknown> | null | undefined): string {
  if (!track) return '';
  const raw = track.id ?? track.qobuzTrackId ?? track.serviceTrackId ?? track.trackId;
  return raw != null ? String(raw) : '';
}

function getAuthToken(): string | null {
  try {
    const raw = localStorage.getItem('maestro_auth');
    if (!raw) return null;
    const { accessToken } = JSON.parse(raw);
    return accessToken || null;
  } catch {
    return null;
  }
}

export async function pushQueueSelectionToServer(queueIndex: number, track: Record<string, unknown>): Promise<void> {
  const token = getAuthToken();
  if (!token) return;
  const trackId = trackIdFromRow(track);
  try {
    await fetch(`${CLOUD_API_URL}/api/queue/sync`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'omit',
      body: JSON.stringify({
        queueIndex,
        currentTrackId: trackId || null,
        currentTrack: {
          id: trackId,
          title: track.title || '',
          artist: track.artist || '',
          album: track.album || '',
          artUrl: track.artworkUrl || track.artUrl || track.coverUrl || '',
          formatId: track.formatId || 27,
          qobuzTrackId: track.qobuzTrackId || track.serviceTrackId || '',
          duration: track.duration || 0,
          source: track.source || 'library',
        },
        playbackState: 'loading',
        activeSource: 'library',
        clientSelectionAt: Date.now(),
      }),
      signal: AbortSignal.timeout(5000),
    });
  } catch {
    // Best-effort
  }
}
